module.exports = __webpack_public_path__ + "img/google.9b70f436.svg";